import AddIcon from '@mui/icons-material/Add';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import { styled } from '@mui/material/styles';

export const StyledBlockIcon = styled(BlockIcon)`
  height: 18px;

  margin-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.error.main};
`;

export const StyledCheckIcon = styled(CheckIcon)`
  height: 18px;

  margin-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.success.main};
`;

export const StyledAddIcon = styled(AddIcon)`
  height: 18px;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledRemoveIcon = styled(RemoveIcon)`
  height: 18px;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledCloseIcon = styled(CloseIcon)`
  height: 18px;

  margin-right: ${({ theme }) => theme.spacing(1)};
`;
